import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const Badge = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
  padding: "4px 8px",

  backgroundColor: colors.warning50,
  borderRadius: "100px",
  height: "16px",
  width: "16px",
  color: colors.warning600,
  fontFamily: "Manrope",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
  marginTop: "4px",
}));
